import Email from './Email.vue';
export default Email;



// WEBPACK FOOTER //
// ./src/components/parts/verify/email/index.js